module.exports = __webpack_public_path__ + "static/edit-file-to-change-active-tab-of-products-by-category-1-4fa44eb95a9ade2abfbe32193ef4a447.png";